module.exports = __webpack_public_path__ + "img/expenditureItem.9e09f58e.svg";